class Iframe {
    constructor(id, nome, url, dadosIntegracao, tipoIntegracao, iframeAutenticacao, privilegio){
        this.id = id;
        this.nome = nome;
        this.url = url;
        this.dadosIntegracao = dadosIntegracao;
        this.tipoIntegracao = tipoIntegracao;
        this.iframeAutenticacao = iframeAutenticacao;
        this.privilegio = privilegio;
    }
}

export default Iframe;
